/* screens/workspace/canvas/CanvasEditForm.jsx — каркас edit-режима канваса (S6).
   Та же шапка, что у CanvasViewForm, но подвал — «Отмена» + «Сохранить» (busy).
   Используется MenuCanvas/ABCCanvas/FoodcostCanvas/InventoryCanvas при mode='edit'.
   ХЕНДОФФ → frontend/components/chat/CanvasEditForm.jsx. */

import { Icon } from '../../../components/ui/Icon.jsx';
import { CanvasViewForm } from './CanvasViewForm.jsx';

  function CanvasEditForm({ eyebrow, icon, title, onClose, onCancel, onSave, busy, saveLabel = 'Сохранить', panel, children }) {
    const footer = (
      <div className="canvas-foot__edit">
        <button type="button" className="btn btn--secondary btn--sm" onClick={onCancel} disabled={busy}>Отмена</button>
        <button type="button" className="btn btn--primary btn--sm" onClick={onSave} disabled={busy}>
          {busy && <Icon name="spinner" size={14} className="spin" />}
          <span className="btn__label">{saveLabel}</span>
        </button>
      </div>
    );
    return (
      <CanvasViewForm eyebrow={eyebrow} icon={icon} title={title} onClose={onClose} footer={footer} panel={panel} busy={busy}>
        {children}
      </CanvasViewForm>
    );
  }

export { CanvasEditForm };
